// Smoothly scrolls to an in-page section. Routes through the Lenis instance
// (exposed on window by usePremiumMotion) when smooth-scroll is active, since
// native #anchor jumps are otherwise swallowed by the Lenis RAF loop.
const HEADER_OFFSET = 76;

export const scrollToSection = (hash) => {
  if (!hash || hash === '#') return false;
  const el = document.querySelector(hash);
  if (!el) return false;
  if (window.lenis && typeof window.lenis.scrollTo === 'function') {
    window.lenis.scrollTo(el, { offset: -HEADER_OFFSET });
  } else {
    const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }
  return true;
};
